import { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";

import PropTypes from "prop-types";

function StatsTable({ minHeight = 0, data = [], title = "" }) {
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("title");
    const [neutral, setNeutral] = useState(true);

    const handleSortRequest = (name) => {
        if (orderBy === name) {
            if (neutral) {
                setOrder("asc");
                setNeutral(false);
            } else if (order === "asc") {
                setOrder("desc");
            } else {
                setOrderBy("");
                setNeutral(true);
            }
        } else {
            setOrderBy(name);
            setOrder("asc");
            setNeutral(false);
        }
    };

    const sortedData = neutral
        ? data
        : [...data].sort((a, b) => {
              if (order === "asc") {
                  return a[orderBy] < b[orderBy] ? -1 : 1;
              } else {
                  return a[orderBy] > b[orderBy] ? -1 : 1;
              }
          });

    return (
        <TableContainer
            style={{
                boxShadow: "inset rgb(219 219 219) 0px 0px 5px",
            }}
        >
            <Table
                sx={{
                    minWidth: 450,
                }}
                size="small"
                aria-label="a dense table"
                style={{
                    minHeight: minHeight,
                }}
            >
                <TableHead>
                    <TableRow>
                        <TableCell
                            sx={{
                                fontWeight: 600,
                                fontSize: "0.75rem",
                            }}
                        >
                            <TableSortLabel
                                active={orderBy === "title"}
                                direction={orderBy === "title" ? order : "asc"}
                                onClick={() => handleSortRequest("title")}
                            >
                                {title}
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                fontWeight: 600,
                                fontSize: "0.75rem",
                            }}
                            align="right"
                        >
                            <TableSortLabel
                                active={orderBy === "sample_size"}
                                direction={orderBy === "sample_size" ? order : "asc"}
                                onClick={() => handleSortRequest("sample_size")}
                            >
                                Count
                            </TableSortLabel>
                        </TableCell>
                        <TableCell
                            sx={{
                                fontWeight: 600,
                                fontSize: "0.75rem",
                            }}
                            align="right"
                        >
                            <TableSortLabel
                                active={orderBy === "percentage"}
                                direction={orderBy === "percentage" ? order : "asc"}
                                onClick={() => handleSortRequest("percentage")}
                            >
                                Percentage
                            </TableSortLabel>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.map((row) => (
                        <TableRow
                            key={row.title}
                            sx={{
                                "&:last-child td, &:last-child th": {
                                    border: 0,
                                },
                            }}
                        >
                            <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                    fontSize: "0.75rem",
                                }}
                            >
                                {row.title}
                            </TableCell>
                            <TableCell
                                sx={{
                                    fontSize: "0.75rem",
                                }}
                                align="right"
                            >
                                {row.sample_size}
                            </TableCell>
                            <TableCell
                                sx={{
                                    fontSize: "0.75rem",
                                }}
                                align="right"
                            >
                                {row.percentage.toFixed(2)}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

// Typechecking props for the StatsTable
StatsTable.propTypes = {
    title: PropTypes.string,
    minHeight: PropTypes.string,
    data: PropTypes.array,
};

export default StatsTable;
